import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from '../../styles.scss'

class LoadingBar extends Component {
    getProgressStyle = () => {
        const percent = this.props.progress.percent
        return {
            transform: `translateX(-${100 - percent}%)`,
        }
    }

    renderPatchNotes = () => {
        if (!this.props.patchNotes) return null

        return (
            <a role="button" tabIndex="0" onClick={this.props.patchNotesOnClick}>
                {this.props.patchNotes}
            </a>
        )
    }

    renderSteamLogo = () => {
        if (!this.props.steamStartup) return null

        return (
            <span className={styles.steam}>
                <i className="fa fa-steam" />
            </span>
        )
    }

    render() {
        return (
            <div className={styles.loading}>
                <div className={styles.messages}>
                    <div className={styles.version}>
                        {this.props.clientText}
                        {this.renderPatchNotes()}
                    </div>
                    <div>{this.props.progress.message}</div>
                    <div className={styles.version}>
                        {this.props.launcherText}
                        <span id={styles.launcher}>{this.props.launcherVersion}</span>.<span
                            id={styles.ui}
                        >
                            {this.props.uiVersion}
                            {this.renderSteamLogo()}
                        </span>
                    </div>
                </div>
                <div className={styles.bar} />
                <div
                    className={[styles.bar, styles.progress].join(' ')}
                    style={this.getProgressStyle()}
                />
            </div>
        )
    }
}

LoadingBar.propTypes = {
    launcherText: PropTypes.string,
    launcherVersion: PropTypes.number,
    uiVersion: PropTypes.string,
    clientText: PropTypes.string,
    patchNotes: PropTypes.string,
    patchNotesOnClick: PropTypes.func,
    steamStartup: PropTypes.bool,
    progress: PropTypes.shape({
        percent: PropTypes.number,
        message: PropTypes.string,
    }),
}

export default LoadingBar



// WEBPACK FOOTER //
// ./src/features/LoadingBar/components/LoadingBar/component.js